import { makeAuthHeaders } from "../oauth/auth";

export const fetchUserProfilesService = async () => {
  try {
    let headers = await makeAuthHeaders();

    let response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/dcm/profiles`,
      {
        method: "GET",
        headers
      }
    );

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error('UNAUTHORIZED');
      }

      let body = await response.json();
      throw new Error(body.message);
    }

    return response.json();
  } catch (e) {
    console.log(e);
    throw e;
  }
};